import { render, staticRenderFns } from "./CentrosDeConsumo.vue?vue&type=template&id=06e3b9ef&scoped=true&"
import script from "./CentrosDeConsumo.vue?vue&type=script&lang=js&"
export * from "./CentrosDeConsumo.vue?vue&type=script&lang=js&"
import style0 from "./CentrosDeConsumo.vue?vue&type=style&index=0&id=06e3b9ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e3b9ef",
  null
  
)

export default component.exports